"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PersonIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.96 8c1.634 0 2.96-1.343 2.96-3S9.593 2 7.96 2C6.325 2 5 3.343 5 5s1.325 3 2.96 3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.07 13.654A5.79 5.79 0 017.745 9h.508a5.79 5.79 0 015.677 4.654.29.29 0 01-.284.346H2.353a.29.29 0 01-.284-.346z"
  })))
});
PersonIcon.displayName = 'PersonIcon';
var _default = exports.default = PersonIcon;